module.exports = __webpack_public_path__ + "img/araare-sketchwork-big.45efe3e8.png";